module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<table class="table table-striped table-hover table-bordered" data-classes="table table-striped table-hover table-bordered">\n    <thead>\n        <tr>\n            ';
 if(acceptLocalization) { ;
__p += '\n            <th class="' +
((__t = (localizeHeaderClassName)) == null ? '' : __t) +
' notexport notsort" data-align="center" data-sortable="false" title="Localisation">\n                <!--Localisation-->\n            </th>\n            ';
 } ;
__p += '\n\n            ';
 
            if (colNames.length !== 0) {
            _.each(colNames,function(colName) { ;
__p += '\n            <th class="' +
((__t = (headersRowClassName)) == null ? '' : __t) +
'" data-sortable="true">\n                <span class="DescartesUIText">' +
((__t = (colName)) == null ? '' : __t) +
'</span>\n            </th>\n            ';
 });
             } else {
            ;
__p += '           		\n			<tr><th style="display:none;">&nbsp;</th></tr>\n             ';
         
             }
             ;
__p += '\n        </tr>\n    </thead>\n    <tbody>\n        ';
 _.each(model,function(data) { ;
__p += '\n        <tr>\n            ';
 if(acceptLocalization) {;
__p += '\n\n            <td class="' +
((__t = (evenLocalizeCellClassName)) == null ? '' : __t) +
'" data-align="center" data-bounds="' +
((__t = (data['bounds'])) == null ? '' : __t) +
'">\n                <span class="fa fa-map-marker" title="Se localiser sur l\'élément"></span>\n            </td>\n            ';
 } ;
__p += '\n\n            ';
 _.each(colNames,function(colName) {
                var cellData = data[colName];
                if (!cellData) {
                   cellData = "undefined";
                }
                if (cellData.toLowerCase().indexOf('http://') === 0 || cellData.toLowerCase().indexOf('https://') === 0 ) {
                    cellData = "<a href=\""+cellData+"\" title=\""+cellData+"\" target=\"_blank\"><span class=\"DescartesUIText\">Lien</span></a>";
                }
            ;
__p += '\n            <td><span class="DescartesUIText">' +
((__t = (cellData)) == null ? '' : __t) +
'</span></td>\n            ';
 });;
__p += '\n        </tr>\n        ';
 });;
__p += '\n    </tbody>\n    ';
 if(filterColumns) { ;
__p += '\n    <tfoot>\n        <tr>\n            ';
 if(acceptLocalization) { ;
__p += '\n            <th></th>\n            ';
 } ;
__p += '\n\n            ';
 
            if (colNames.length !== 0) {
            _.each(colNames,function(colName) { ;
__p += '\n            <th>' +
((__t = (colName)) == null ? '' : __t) +
'</th>\n            ';
 });
             } else {
            ;
__p += '           		\n			<th></th>\n             ';
         
             }
             ;
__p += '\n        </tr>\n    </tfoot>\n    ';
 } ;
__p += '\n</table>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/DataGrid.ejs
// module id = 314
// module chunks = 0